module.exports = __webpack_public_path__ + "img/sort-unselected.9634a967.svg";